var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizes-2021-promo-product-list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"prizes-2021-promo-product-list__item"},[_c('Prizes2021PromoProduct',{attrs:{"product":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }